import { isValidElement, useMemo } from "react";

import {
  AttributeCard,
  AttributeCardValue,
} from "@/components/Card/AttributeCard";
import ResponseMessage from "@/components/Error/ResponseMessage";
import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { useCommonTranslation } from "@/hooks/useCommonTranslation";
import { useHover } from "@/hooks/useHover";

import type { CFormItemComponentBaseProps } from "../../types/component-types";
import { CFormItemEditButtonGroup } from "../CFormItemEditButtonGroup";
type CFormItemBaseProps = CFormItemComponentBaseProps;
export function CFormAttributeCardItemLayout(props: CFormItemBaseProps) {
  const t = useCommonTranslation();
  const { ref: itemRef, isHovered } = useHover<HTMLDivElement>();

  const displayActions =
    !props.readonly &&
    !props.hideActionButtons &&
    (isHovered || props.isEditing);

  const errors = useMemo(() => {
    return typeof props.errors === "string"
      ? props.errors
      : props.errors?.join("\n");
  }, [props.errors]);

  return (
    <AttributeCard
      titleElement={
        <HStack className="items-center h-6">
          <HStack className="gap-2 items-center h-4 flex-1">
            {typeof props.label === "string" ? (
              <Text variant="label">{props.label}</Text>
            ) : (
              props.label
            )}
            {props.isEditing && !props.required && (
              <Text variant="labelSmall" className="text-muted-foreground">
                {t("optional")}
              </Text>
            )}
          </HStack>
          <CFormItemEditButtonGroup
            display={displayActions}
            isEditing={props.isEditing}
            onStartEdit={props.onStartEdit}
            onCancel={props.onCancel}
            onSave={props.onSave}
            isPending={props.isPending}
          />
        </HStack>
      }
      ref={itemRef}
      colSpan={props.colSpan ?? 2}
      className="box-border overflow-x-hidden"
    >
      <div className="pl-2 min-h-10">
        {props.isEditing ? (
          <VStack>
            {props.writeComponent}
            {errors && (
              <ResponseMessage className="whitespace-pre-line">
                {errors}
              </ResponseMessage>
            )}
          </VStack>
        ) : // ReactElementかどうかで分岐
        isValidElement(props.readComponent) ? (
          <div className="flex items-center">{props.readComponent}</div>
        ) : (
          <AttributeCardValue>{props.readComponent}</AttributeCardValue>
        )}
      </div>
    </AttributeCard>
  );
}
